import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { BottomNav } from "./components/BottomNav";
import AuthPage from "./pages/AuthPage";
import MapPage from "./pages/MapPage";
import SignalPage from "./pages/SignalPage";
import ActivityPage from "./pages/ActivityPage";
import AdminPage from "./pages/AdminPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="h-[60vh] grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-amber-400" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const Shell = () => {
  const { user } = useAuth();
  return (
    <div className="grain min-h-screen flex flex-col">
      <Header />
      <main className="relative z-[2] flex-1">
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route path="/reimposta-password" element={<ResetPasswordPage />} />
          <Route path="/" element={<Protected><MapPage /></Protected>} />
          <Route path="/segnala" element={<Protected><SignalPage /></Protected>} />
          <Route path="/attivita" element={<Protected><ActivityPage /></Protected>} />
          <Route path="/admin" element={<Protected admin><AdminPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      {user && <BottomNav />}
    </div>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
        <Toaster theme="dark" position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
